// Water Treatment System Products Data
    export const waterTreatmentSystemProducts = {
      'uf-system': {
        id: 'uf-system',
        title: 'UF System',
        name: 'UF System',
        category: 'Water Treatment System',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/3550b0ee7cc0fc226dcf25ff8d79cfa6.jpg',
        shortDescription: 'Integrated Ultrafiltration (UF) systems for reliable water purification and pretreatment.',
        description: 'Complete, pre-engineered Ultrafiltration (UF) systems designed for various water treatment applications, providing high-quality purified water.',
        longDescription: 'Our integrated UF Systems are complete, skid-mounted water treatment solutions built around advanced hollow fiber ultrafiltration membrane technology. These systems are designed for reliability and ease of operation, effectively removing suspended solids, bacteria, viruses, and other high-molecular-weight substances. They are ideal for producing high-quality purified water, treating surface or groundwater, and as a robust pretreatment for Reverse Osmosis (RO) systems. Customizable to meet specific flow rate and water quality requirements.',
        features: [
          'Integrated, skid-mounted design for easy installation',
          'Advanced hollow fiber UF membrane technology',
          'High removal efficiency for suspended solids, bacteria, and viruses',
          'Automated operation with PLC control',
          'Includes automatic backwash and chemical cleaning systems',
          'Robust pretreatment for RO systems, extending RO membrane life',
          'Customizable flow rates and configurations'
        ],
        applications: [
          'Municipal water purification',
          'Pretreatment for RO desalination systems',
          'Industrial process water',
          'Wastewater reuse and recycling',
          'Clarification of surface water and groundwater',
          'Food and beverage industry'
        ],
        specifications: {
          'UF Membrane': 'PVDF, PES, PAN (optional)',
          'Control System': 'PLC with HMI touchscreen',
          'System Frame': 'Stainless Steel or Carbon Steel',
          'Piping': 'UPVC or Stainless Steel',
          'Included Components': 'Feed pump, backwash pump, air compressor, chemical dosing pumps, piping, valves, instrumentation.',
          'Operating Mode': 'Fully automatic'
        },
        technicalData: {}
      },
      'ro-system': {
        id: 'ro-system',
        title: 'RO System',
        name: 'RO System',
        category: 'Water Treatment System',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/776df3033730bc966a5f2b12a0c5c043.jpg',
        shortDescription: 'Industrial Reverse Osmosis (RO) system for high-purity water production.',
        description: 'A robust, skid-mounted Reverse Osmosis (RO) system designed for industrial applications, delivering high-quality purified water consistently.',
        longDescription: 'Our industrial RO System is a complete, pre-engineered water treatment solution designed for reliability and high performance. It effectively removes dissolved salts, organic matter, bacteria, and other impurities from water. The system is built on a sturdy frame and includes pre-treatment, high-pressure pumps, RO membranes, and a PLC control system for automated operation. It is ideal for various industrial processes requiring high-purity water.',
        features: [
          'Skid-mounted, integrated design for easy installation.',
          'High-rejection RO membranes for superior performance.',
          'Automated operation with PLC control panel.',
          'Durable construction with stainless steel components.',
          'Includes pre-treatment to protect membranes.',
          'Customizable to meet specific flow rate and quality needs.'
        ],
        applications: [
          'Industrial process water',
          'Boiler feed water',
          'Food and beverage industry',
          'Pharmaceutical manufacturing',
          'Electronics and semiconductor production',
          'Drinking water production'
        ],
        specifications: {
          'Capacity': 'Varies based on configuration (e.g., 1000 L/H and up)',
          'RO Membranes': '4040, 8040, 10040 series, multiple elements',
          'Control System': 'PLC with HMI Touchscreen',
          'Frame Material': 'Stainless Steel (SS304/SS316)',
          'Piping': 'UPVC or Stainless Steel',
          'Operating Mode': 'Fully automatic with safety protections'
        },
        technicalData: {}
      }
    };

    export const waterTreatmentSystemProductsList = [
      {
        id: 'uf-system',
        name: 'UF System',
        category: 'Water Treatment System',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/3550b0ee7cc0fc226dcf25ff8d79cfa6.jpg',
        shortDescription: 'Integrated Ultrafiltration (UF) systems for reliable water purification and pretreatment.',
        description: 'Complete, pre-engineered Ultrafiltration (UF) systems designed for various water treatment applications, providing high-quality purified water.',
        features: [
          'Integrated, skid-mounted design',
          'Advanced hollow fiber UF membrane technology',
          'Automated operation with PLC control'
        ],
        applications: [
          'Municipal water purification',
          'Pretreatment for RO systems',
          'Wastewater reuse and recycling'
        ]
      },
      {
        id: 'ro-system',
        name: 'RO System',
        category: 'Water Treatment System',
        image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/776df3033730bc966a5f2b12a0c5c043.jpg',
        shortDescription: 'Industrial Reverse Osmosis (RO) system for high-purity water production.',
        description: 'A robust, skid-mounted Reverse Osmosis (RO) system designed for industrial applications, delivering high-quality purified water consistently.',
        features: [
          'Skid-mounted, integrated design',
          'High-rejection RO membranes',
          'Automated operation with PLC control'
        ],
        applications: [
          'Industrial process water',
          'Food and beverage industry',
          'Pharmaceutical manufacturing'
        ]
      }
    ];

    export default waterTreatmentSystemProducts;